/*
scrollToggle
スクロールを止める、
 */
var $body = $('body');
var $window = $(window);
var $menu = $('#js-menu');
var $content = $('#js-content');
var $search = $('#js-search');

var scrollToggle = {
    forbid: function() {
        var offsetTop = $(window).scrollTop() * -1;
        $body.addClass('noscroll');
        $content.css({ 'top': offsetTop + 'px' });
        $body.css({ 'height': window.innerHeight + 'px' });
        $search.children().css({ 'height': window.innerHeight + 'px' });
        $menu.children().css({ 'height': window.innerHeight + 'px' });
    },
    allow: function() {
        var offsetTop = $content.position().top * -1;
        $body.removeClass('noscroll');

        if (offsetTop > 0) {
            $body.scrollTop(offsetTop);
        }

        $content.css({ 'top': '0px' });
        $body.css({ 'height': 'auto' });
        $search.children().css({ 'height': 'auto' });
        $menu.children().css({ 'height': 'auto' });
    }
}

module.exports = scrollToggle;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/module/scrollToggle.js
 **/